function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-/-social-/-telegram",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(14.000000, 16.000000)",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("line", {
  x1: 23.1614187,
  y1: 27.142901,
  x2: 22.4577992,
  y2: 33.034465,
  id: "Path-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6715015,25.4720293 L35.8076905,14.6073775 L23.1614187,27.142901 L34.5513601,35.5608634 C34.9955072,35.8891191 35.6216633,35.7951706 35.9499191,35.3510235 C36.0358417,35.2347657 36.0955363,35.1012606 36.1248892,34.9597085 L40.9308709,11.7831604 C41.0430093,11.24238 40.6955263,10.7130848 40.1547459,10.6009464 C39.9686128,10.5623491 39.7753341,10.5776041 39.5975607,10.6449238 L12.3503978,20.9629417 C11.8339055,21.1585282 11.5737599,21.7357821 11.7693464,22.2522745 C11.8667152,22.5093998 12.0656546,22.7150925 12.3193875,22.8209874 L18.6715015,25.4720293 L18.6715015,25.4720293 L21.5131377,33.1266581 C21.705346,33.6444171 22.2808882,33.9083282 22.7986472,33.7161199 C22.9188152,33.6715098 23.0292861,33.6042128 23.124045,33.5178928 L26.9668429,30.0173272 L26.9668429,30.0173272",
  id: "Path-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.7871631,0.538898146 C14.380449,0.179632715 20.0428705,0 25.7744276,0 C31.5830594,0 37.3917798,0.184496389 43.2005889,0.553489167 L43.2005891,0.553485826 C47.766761,0.843542605 51.3886356,4.51333566 51.618655,9.08292534 C51.872885,14.1334838 52,19.1477768 52,24.1258041 C52,29.06388 51.8749172,34.0019332 51.6247515,38.9399638 L51.624753,38.9399638 C51.3934623,43.5054214 47.7764177,47.172285 43.214551,47.4660031 C37.6853893,47.822001 32.0565747,48 26.3281072,48 C20.4852661,48 14.6423019,47.8148223 8.79921437,47.4444669 L8.79921419,47.4444697 C4.23261406,47.1550226 0.610069205,43.4851544 0.379912849,38.9151824 C0.126637616,33.8861632 0,28.8836593 0,23.9076706 C0,18.9602638 0.125186996,14.0128742 0.375560987,9.06550176 L0.375563935,9.06550191 C0.60664659,4.49932493 4.22454491,0.831962192 8.7871631,0.538898146 Z",
  id: "Rectangle"
})));

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.59069a19.svg";
export { ForwardRef as ReactComponent };